// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "Button\n{\n    size:lg;\n}\n\n#ButtonMargin{\nmargin-top: 5rem;\n}", ""]);
// Exports
module.exports = exports;
